<template lang="pug">
	.snackbar-container(v-if="show")
		slot(:close="close") Test text
		IconClose(class="icon-close" @click="$emit('close')")
</template>

<script>
import IconClose from './IconClose';

export default {
  name       : 'custom-snackbar',
  components : {
    IconClose
  },
  props : {
    show : Boolean,
    text : String,
  },

  methods : {
    close() {
      this.$emit( 'close' );
    }
  }
};
</script>

<style lang="scss" scoped>
.snackbar-container {
	position: absolute;
	background-color: white;
	bottom: 30px;
	left: 50%;
	box-shadow: $floatingObject;
	padding: 16px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	pointer-events: auto !important;

	.icon-close {
		margin-left: 30px;
		color: $cancel;
	}
}
</style>
